import React, { useState } from 'react';
import './DefaultCountrySelectBox.scss';
import shortid from 'shortid';
import PolandFlagIcon from 'images/icons/icn-flag-pl.svg';
import EnglishFlagIcon from 'images/icons/icn-flag-gb.svg';
import { withTranslation } from 'react-i18next';
import CountrySelectBox from '../CountrySelectBox';

const languages = [
  {
    id: shortid(),
    text: 'Pl',
    value: 'pl',
    icon: <PolandFlagIcon />,
  },
  {
    id: shortid(),
    text: 'En',
    value: 'en',
    icon: <EnglishFlagIcon />,
  },
];

function getLanguage(value) {
  return languages.find((lng) => lng.value === value);
}

const DefaultCountrySelectBox = ({ t, i18n }) => {
  const [language, setLanguage] = useState(getLanguage(localStorage.getItem('language') || 'pl'));

  const handleLanguageChange = ({ target: { value } }) => {
    i18n.changeLanguage(value, () => {
      localStorage.setItem('language', value);
      setLanguage(getLanguage(value));
    });
  };

  return (
    <CountrySelectBox
      value={
        <div className="option">
          {language.icon} <span className="optionText">{language.text}</span>
        </div>
      }
      label={t('language')}
      onSelect={handleLanguageChange}
      options={languages}
      render={(option) => (
        <div className="option">
          {option.icon} <span className="optionText">{option.text}</span>
        </div>
      )}
    />
  );
};

export default withTranslation()(DefaultCountrySelectBox);
